export function searchHandler() {
    let selectedItemMainSearch = 0;
    let numberOfMainSearchItems = 0;
    let numberOfMainSearchConditions = 0;
    let numberOfMainSearchDrugs = 0;
    let numberOfMainSearchDrugGroups = 0;
    let numberOfMainSearchNews = 0;
    let numberOfMainSearchBlogPosts = 0;
    let numberOfMainSearchGenericDrugs = 0;
    let selectedItemConditionsSearch = 0;
    let numberOfConditionsSearchItems = 0;
    let selectedItemDrugsSearch = 0;
    let numberOfDrugsSearchItems = 0;

    $(".search-icon").click(function () {
        $(this).prev().addClass("d-block");
        $(".search-mobile-wrapper input.d-block").next().click(function(e){
            let value = $(this).prev().val();
            let filterParam = $(this).prev().attr('data-only');
            if (value.length > 0) {
                if (filterParam) {
                    window.location.href = `/pretraga?term=${value}&&filter=${filterParam}`;
                } else {
                    window.location.href = `/pretraga?term=${value}`;
                }
            }
        });
    });

    let conditionsTimeoutId = null;
    let drugsTimeoutId = null;
    $("input.search").keyup(function(e){
        let value = $(this).val();
        let filterParam = $(this).attr('data-only');
        if(e.keyCode == 13)
        {
            if (value.length > 0) {
                if (filterParam) {
                    window.location.href = `/pretraga?term=${value}&&filter=${filterParam}`;
                } else {
                    window.location.href = `/pretraga?term=${value}`;
                }
            }

        }

        if(filterParam === 'conditions') {

            if (e.keyCode === 40 || e.keyCode === 38 || e.keyCode === 13) {
                selectedItemConditionsSearch = conditionsSearchKeyboardNavHandler(e);
                return;
            }

            clearTimeout(conditionsTimeoutId);
    
            conditionsTimeoutId = setTimeout(async function() {
                if (value.length > 1) {
                    $.get( `${process.env.MIX_PUBLIC_API_BASE_URL}/public-api/conditions?term=${value}`, function( data ) {
                        data = data.slice(0, 5);
                        renderConditionsResults(data);
                        selectedItemConditionsSearch = 0;
                        numberOfConditionsSearchItems = data.length;
                    });
                } else {
                    $('.homepage-conditions-dropdown').removeClass('show');
                }
            }, 300)
        }

        if(filterParam === 'drugs') {

            if (e.keyCode === 40 || e.keyCode === 38 || e.keyCode === 13) {
                selectedItemDrugsSearch = drugsSearchKeyboardNavHandler(e);
                return;
            }

            clearTimeout(drugsTimeoutId);
    
            drugsTimeoutId = setTimeout(async function() {
                if (value.length > 1) {
                    $.get( `${process.env.MIX_PUBLIC_API_BASE_URL}/public-api/drugs?term=${value}`, function( data ) {
                        data = data.slice(0, 5);
                        renderDrugsResults(data);
                        selectedItemDrugsSearch = 0;
                        numberOfDrugsSearchItems = data.length;
                    });
                } else {
                    $('.homepage-drugs-dropdown').removeClass('show');
                }
            }, 300)
        }
    });

    let timeoutId = null;

    $("input.main-search").keyup(function(e){
        if (e.keyCode === 40 || e.keyCode === 38 || e.keyCode === 13) {
            selectedItemMainSearch = mainSearchKeyboardNavHandler(e);
            return;
        }

        clearTimeout(timeoutId);

        timeoutId = setTimeout(async function() {
            let value = e.target.value;
            if (value.length > 1) {
                $.get( `${process.env.MIX_PUBLIC_API_BASE_URL}/public-api/search?term=${value}`, function( data ) {
                    rendeResults(data);
                    numberOfMainSearchItems = data.conditions.length 
                        + data.drugs.length 
                        + data.drug_groups.length 
                        + data.generic_drugs.length
                        + data.news.length
                        + data.healthy_life.length;

                    numberOfMainSearchConditions = data.conditions.length;
                    numberOfMainSearchDrugs = data.drugs.length;
                    numberOfMainSearchDrugGroups = data.drug_groups.length;
                    numberOfMainSearchGenericDrugs = data.generic_drugs.length;
                    numberOfMainSearchNews = data.news.length;
                    numberOfMainSearchBlogPosts = data.healthy_life.length;
                    selectedItemMainSearch = 0;
                });
            } else {
                $('.main-search-dropdown').removeClass('show');
            }
        }, 500)
    });

    function rendeResults(data) {
        let $resultsDropdown = $('.main-search-dropdown');
        $resultsDropdown.empty();
        let conditionResultsHtml = '<div class="search-result-section">';
        let drugsResultsHtml = '<div class="search-result-section">';
        let drugGroupsResultsHtml = '<div class="search-result-section">';
        let genericDrugsResultsHtml = '<div class="search-result-section">';
        let newsResultsHtml = '<div class="search-result-section">';
        let blogPostsResultsHtml = '<div class="search-result-section">';
        if (data.conditions.length > 0) {
            conditionResultsHtml += `
                <h4 class="search-results-title searchResultsTitle">Bolesti</h4>
                <ul class="search-results-list ">`;
            data.conditions.forEach(condition => {
                conditionResultsHtml += `<li><a href="/bolesti/${condition.slug}-${condition.id}">${condition.name}</a></li>`
            });
            conditionResultsHtml += `</ul>`;
        }
        if (data.drugs.length > 0) {
            drugsResultsHtml += `
                <h4 class="search-results-title searchResultsTitle">Lekovi</h4>
                <ul class="search-results-list ">`;
            data.drugs.forEach(drug => {
                drugsResultsHtml += `<li><a href="/lek/${drug.slug}-${drug.id}">${drug.name}</a></li>`
            });
            drugsResultsHtml += `</ul>`;
        }
        if (data.drug_groups.length > 0) {
            drugGroupsResultsHtml += `
                <h4 class="search-results-title searchResultsTitle">Grupe lekova</h4>
                <ul class="search-results-list ">`;
            data.drug_groups.forEach(drugGroup => {
                drugGroupsResultsHtml += `<li><a href="/lekovi/${drugGroup.slug}-${drugGroup.id}">${drugGroup.name}</a></li>`
            });
            drugGroupsResultsHtml += `</ul>`;
        }
        if (data.generic_drugs.length > 0) {
            genericDrugsResultsHtml += `
                <h4 class="search-results-title searchResultsTitle">Generički lekovi</h4>
                <ul class="search-results-list ">`;
            data.generic_drugs.forEach(genericDrug => {
                genericDrugsResultsHtml += `<li><a href="/genericki-lekovi/${genericDrug.slug}-${genericDrug.id}">${genericDrug.name}</a></li>`
            });
            genericDrugsResultsHtml += `</ul>`;
        }
        if (data.news.length > 0) {
            newsResultsHtml += `
                <h4 class="search-results-title searchResultsTitle">Vesti</h4>
                <ul class="search-results-list ">`;
            data.news.forEach(singleNews => {
                newsResultsHtml += `<li><a href="/vesti/${singleNews.slug}">${singleNews.title}</a></li>`
            });
            newsResultsHtml += `</ul>`;
        }
        if (data.healthy_life.length > 0) {
            blogPostsResultsHtml += `
                <h4 class="search-results-title searchResultsTitle">Živi zdravo</h4>
                <ul class="search-results-list ">`;
            data.healthy_life.forEach(post => {
                blogPostsResultsHtml += `<li><a href="/vesti/${post.slug}">${post.title}</a></li>`
            });
            blogPostsResultsHtml += `</ul>`;
        }

        conditionResultsHtml += '</div>';
        drugsResultsHtml += '</div>';
        drugGroupsResultsHtml += '</div>';
        genericDrugsResultsHtml += '</div>';
        newsResultsHtml += '</div>';
        blogPostsResultsHtml += '</div>';
        $resultsDropdown.append($(conditionResultsHtml));
        $resultsDropdown.append($(drugsResultsHtml));
        $resultsDropdown.append($(drugGroupsResultsHtml));
        $resultsDropdown.append($(genericDrugsResultsHtml));
        $resultsDropdown.append($(newsResultsHtml));
        $resultsDropdown.append($(blogPostsResultsHtml));
        $('.main-search-dropdown').addClass('show');
        if (data.drugs.length === 0 
            && data.conditions.length === 0 
            && data.drug_groups.length === 0
            && data.generic_drugs.length === 0
            && data.news.length === 0
            && data.healthy_life.length === 0
        ) {
            $('.main-search-dropdown').removeClass('show');
        }
    }

    function renderConditionsResults(data) {
        let $resultsDropdown = $('.homepage-conditions-dropdown');
        $resultsDropdown.empty();
        let conditionResultsHtml = `<ul class="search-results-list">`;
        if (data.length > 0) {
            data.forEach(condition => {
                conditionResultsHtml += `<li><a href="/bolesti/${condition.slug}-${condition.id}">${condition.name}</a></li>`
            });
        } else {
            conditionResultsHtml += `<li>Nema rezultata</li>`;
        }
        conditionResultsHtml += `</ul>`;
        $resultsDropdown.append($(conditionResultsHtml));
        $('.homepage-conditions-dropdown').addClass('show');
    }

    function renderDrugsResults(data) {
        let $resultsDropdown = $('.homepage-drugs-dropdown');
        $resultsDropdown.empty();
        let drugResultsHtml = `<ul class="search-results-list">`;
        if (data.length > 0) {
            data.forEach(drug => {
                drugResultsHtml += `<li><a href="/lek/${drug.slug}-${drug.id}">${drug.name}</a></li>`
            });
        } else {
            drugResultsHtml += `<li>Nema rezultata</li>`;
        }
        drugResultsHtml += `</ul>`;
        $resultsDropdown.append($(drugResultsHtml));
        $('.homepage-drugs-dropdown').addClass('show');
    }

    $('body').click(function() {
        $('.homepage-drugs-dropdown').removeClass('show');
        $('.homepage-conditions-dropdown').removeClass('show');
        $('.main-search-dropdown').removeClass('show');
        $('.tab-content-search-dropdown').removeClass('show');
        $('.symptom-test-search-dropdown').removeClass('show');
        $('#current-mediactions').val('');
        $('#illness-hystory').val('');
        $('#symptoms-input').val('');
    });

    
    function mainSearchKeyboardNavHandler(e) {

        if (e.keyCode === 40) {
            selectedItemMainSearch =  selectedItemMainSearch === numberOfMainSearchItems ? 1 : selectedItemMainSearch + 1;
        }
        if (e.keyCode === 38) {
            selectedItemMainSearch =  selectedItemMainSearch < 2 ? numberOfMainSearchItems : selectedItemMainSearch - 1;
        }
        if (e.keyCode === 13) {
            if ($('.main-search-dropdown li.selected').length > 0) {
                window.location.href = $('.main-search-dropdown li.selected a').attr("href");
            }
            return selectedItemMainSearch;
        }

        $(`.main-search-dropdown li`).removeClass('selected');

        if(selectedItemMainSearch > (numberOfMainSearchConditions + numberOfMainSearchDrugs + numberOfMainSearchDrugGroups + numberOfMainSearchGenericDrugs + numberOfMainSearchNews)) {
            $(`.main-search-dropdown .search-result-section:nth-of-type(6) li:nth-child(${selectedItemMainSearch - numberOfMainSearchConditions - numberOfMainSearchDrugs - numberOfMainSearchDrugGroups - numberOfMainSearchGenericDrugs - numberOfMainSearchNews})`).addClass('selected');
        } else if(selectedItemMainSearch > (numberOfMainSearchConditions + numberOfMainSearchDrugs + numberOfMainSearchDrugGroups + numberOfMainSearchGenericDrugs)) {
            $(`.main-search-dropdown .search-result-section:nth-of-type(5) li:nth-child(${selectedItemMainSearch - numberOfMainSearchConditions - numberOfMainSearchDrugs - numberOfMainSearchDrugGroups - numberOfMainSearchGenericDrugs})`).addClass('selected');
        } else if(selectedItemMainSearch > (numberOfMainSearchConditions + numberOfMainSearchDrugs + numberOfMainSearchDrugGroups)) {
            $(`.main-search-dropdown .search-result-section:nth-of-type(4) li:nth-child(${selectedItemMainSearch - numberOfMainSearchConditions - numberOfMainSearchDrugs - numberOfMainSearchDrugGroups})`).addClass('selected');
        } else if (selectedItemMainSearch > (numberOfMainSearchConditions + numberOfMainSearchDrugs)) {
            $(`.main-search-dropdown .search-result-section:nth-of-type(3) li:nth-child(${selectedItemMainSearch - numberOfMainSearchConditions - numberOfMainSearchDrugs})`).addClass('selected');
        } else if(selectedItemMainSearch > numberOfMainSearchConditions) {
            $(`.main-search-dropdown .search-result-section:nth-of-type(2) li:nth-child(${selectedItemMainSearch - numberOfMainSearchConditions})`).addClass('selected');
        } else {
            $(`.main-search-dropdown .search-result-section:nth-of-type(1) li:nth-child(${selectedItemMainSearch})`).addClass('selected');
        }

        return selectedItemMainSearch;
        
    }

    function conditionsSearchKeyboardNavHandler(e) {

        if (e.keyCode === 40) {
            selectedItemConditionsSearch =  selectedItemConditionsSearch === numberOfConditionsSearchItems ? 1 : selectedItemConditionsSearch + 1;
        }
        if (e.keyCode === 38) {
            selectedItemConditionsSearch =  selectedItemConditionsSearch === 1 ? numberOfConditionsSearchItems : selectedItemConditionsSearch - 1;
        }
        if (e.keyCode === 13) {
            if ($('.homepage-conditions-dropdown li.selected').length > 0) {
                window.location.href = $('.homepage-conditions-dropdown li.selected a').attr("href");
            }
            return selectedItemConditionsSearch;
        }

        $(`.homepage-conditions-dropdown li`).removeClass('selected');
        $(`.homepage-conditions-dropdown  li:nth-child(${selectedItemConditionsSearch})`).addClass('selected');

        return selectedItemConditionsSearch;   
    }

    function drugsSearchKeyboardNavHandler(e) {

        if (e.keyCode === 40) {
            selectedItemDrugsSearch =  selectedItemDrugsSearch === numberOfDrugsSearchItems ? 1 : selectedItemDrugsSearch + 1;
        }
        if (e.keyCode === 38) {
            selectedItemDrugsSearch =  selectedItemDrugsSearch === 1 ? numberOfDrugsSearchItems : selectedItemDrugsSearch - 1;
        }
        if (e.keyCode === 13) {
            if ($('.homepage-drugs-dropdown li.selected').length > 0) {
                window.location.href = $('.homepage-drugs-dropdown li.selected a').attr("href");
            }
            return selectedItemDrugsSearch;
        }

        $(`.homepage-drugs-dropdown li`).removeClass('selected');
        $(`.homepage-drugs-dropdown  li:nth-child(${selectedItemDrugsSearch})`).addClass('selected');

        return selectedItemDrugsSearch; 
    }


}